// import React from "react";

// const Errorsvg = () => {
//   return (
//     <svg
//       viewBox="0 0 900 500"
//       className="w-full h-full"
//       xmlns="http://www.w3.org/2000/svg"
//       fill="none"
//       aria-hidden="true"
//     >
//       {/* ===== Background blob ===== */}
//       <path
//         d="M120 120 C260 20, 520 20, 700 140 C860 260, 760 420, 520 440 C280 460, 80 360, 120 120Z"
//         fill="#E6F6F9"
//       />

//       {/* ===== Sun ===== */}
//       <circle cx="360" cy="170" r="28" fill="#FFFFFF" opacity="0.9" />

//       {/* ===== Birds ===== */}
//       <path d="M300 160 C305 155, 310 155, 315 160" stroke="#2F4F4F" strokeWidth="2" />
//       <path d="M330 140 C335 135, 340 135, 345 140" stroke="#2F4F4F" strokeWidth="2" />
//       <path d="M280 140 C285 135, 290 135, 295 140" stroke="#2F4F4F" strokeWidth="2" />

//       {/* ===== City skyline ===== */}
//       <g fill="#B6DDE8">
//         <rect x="180" y="200" width="40" height="140" rx="4" />
//         <rect x="240" y="170" width="50" height="170" rx="4" />
//         <rect x="310" y="210" width="36" height="130" rx="4" />
//         <rect x="380" y="160" width="60" height="180" rx="4" />
//         <rect x="460" y="220" width="42" height="120" rx="4" />
//         <rect x="530" y="190" width="50" height="150" rx="4" />
//       </g>

//       {/* ===== Ground line ===== */}
//       <rect x="80" y="360" width="740" height="6" rx="3" fill="#1F2937" />

//       {/* ===== Green bushes ===== */}
//       <path
//         d="M80 360 C120 330, 180 330, 220 360 C260 330, 320 330, 360 360 C400 330, 460 330, 500 360 C540 330, 600 330, 640 360 C680 330, 740 330, 780 360Z"
//         fill="#9BCB65"
//       />

//       {/* ===== Solar panels ===== */}
//       <g transform="translate(260 260)">
//         {/* Panel 1 */}
//         <g transform="skewX(-15)">
//           <rect width="180" height="90" rx="6" fill="#0B5F8A" />
//           <path
//             d="M0 30 H180 M0 60 H180 M45 0 V90 M90 0 V90 M135 0 V90"
//             stroke="#6FB7D6"
//             strokeWidth="1"
//           />
//         </g>

//         {/* Panel 2 */}
//         <g transform="translate(160 -10) skewX(-15)">
//           <rect width="210" height="110" rx="6" fill="#0A6EA8" />
//           <path
//             d="M0 35 H210 M0 70 H210 M52 0 V110 M104 0 V110 M156 0 V110"
//             stroke="#8BC6DF"
//             strokeWidth="1"
//           />
//         </g>
//       </g>
//     </svg>
//   );
// };

// export default Errorsvg;

import React from "react";

const Errorsvg = () => {
  return (
    <svg viewBox="0 0 900 500" className="w-full h-full" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" >
          {/* ===== Background blob ===== */}
      <path d="M120 120 C260 20, 520 20, 700 140 C860 260, 760 420, 520 440 C280 460, 80 360, 120 120Z" fill="#E6F6F9" />

      {/* ===== Sun ===== */}
      <circle cx="360" cy="170" r="28" fill="#FFFFFF" opacity="0.9" >
         <animate attributeName="r" values="26;30;26" dur="3s"repeatCount="indefinite" />
      </circle>

      {/* ===== Birds ===== */}
      <g>
      <path d="M300 160 C305 155, 310 155, 315 160" stroke="#2F4F4F" strokeWidth="2" />
      <path d="M330 140 C335 135, 340 135, 345 140" stroke="#2F4F4F" strokeWidth="2" />
      <path d="M280 140 C285 135, 290 135, 295 140" stroke="#2F4F4F" strokeWidth="2" />
       <animateTransform attributeName="transform" type="translate"  from="0 0" to="20 -5" dur="4s" repeatCount="indefinite" direction="alternate" />
      </g>

      {/* ===== City skyline ===== */}
      <g fill="#B6DDE8">
        <rect x="180" y="200" width="40" height="140" rx="4" />
        <rect x="240" y="170" width="50" height="170" rx="4" />
        <rect x="310" y="210" width="36" height="130" rx="4" />
        <rect x="380" y="160" width="60" height="180" rx="4" />
        <rect x="460" y="220" width="42" height="120" rx="4" />
        <rect x="530" y="190" width="50" height="150" rx="4" />
        <animateTransform attributeName="transform" type="translate" values="0 0; 0 -6; 0 0" dur="5s" repeatCount="indefinite" />
      </g>

      {/* ===== Ground line ===== */}
      <rect x="80" y="360" width="740" height="6" rx="3" fill="#1F2937" />

      {/* ===== Green bushes ===== */}
      <path d="M80 360 C120 330, 180 330, 220 360 C260 330, 320 330, 360 360 C400 330, 460 330, 500 360 C540 330, 600 330, 640 360 C680 330, 740 330, 780 360Z" fill="#9BCB65" >
       <animateTransform attributeName="transform" type="translate" values="0 0; 0 -4; 0 0" dur="3s" repeatCount="indefinite"  />
      </path>
      

      {/* ===== Solar panels ===== */}
      <g transform="translate(260 260)">
        {/* Panel 1 */}
        <g transform="skewX(-15)">
          <rect width="180" height="90" rx="6" fill="#0B5F8A" />
          <path d="M0 30 H180 M0 60 H180 M45 0 V90 M90 0 V90 M135 0 V90" stroke="#6FB7D6" strokeWidth="1" />
        </g>

        {/* Panel 2 */}
        <g transform="translate(160 -10) skewX(-15)">
          <rect width="210" height="110" rx="6" fill="#0A6EA8" />
          <path d="M0 35 H210 M0 70 H210 M52 0 V110 M104 0 V110 M156 0 V110"  stroke="#8BC6DF" strokeWidth="1" />
        </g>
      </g>
    </svg>
  );
};

export default Errorsvg;
